import React from 'react';

const InsertDriveIcon = ({ width = 24, height = 24, fill = '#656263' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20L0.01 0H10L16 6V20H0ZM9 1.5V7H14.5L9 1.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default InsertDriveIcon;
